<template>
  <el-select
    ref="services"
    v-model="selected"
    clearable
    filterable
    :placeholder="$t('selecione-uma-opcao')"
    @change="update()"
  >
    <el-option
      v-for="row of services"
      :key="row.code"
      :label="`${row.name} (${row.code})`"
      :value="row.code"
    ></el-option>
  </el-select>
</template>

<script>
import { ServicesService } from "@/services/customers/services.services";
export default {
  name: "ServicesList",
  data: function () {
    return {
      services: [
        { code: "03247", name: "SEDEX REVERSO" },
        { code: "03301", name: "PAC REVERSO" },
      ],
      selected: "",
    };
  },
  props: {
    current: String,
    // Cliente da reversa: a Reversa Consolidada só aparece se ele a tiver habilitada.
    customer: String,
  },
  watch: {
    customer() {
      this.fetchServices();
    },
  },
  methods: {
    fetchServices() {
      const vm = this;
      ServicesService.reverse(vm.customer)
        .then((response) => {
          vm.services = response.records;
          // Serviço escolhido que não vale para o cliente atual (ex.: consolidada de outro cliente).
          if (vm.selected && !vm.services.some((x) => x.code === vm.selected)) {
            vm.selected = "";
            vm.update();
          }
          setTimeout(() => {
            if (vm.$props.current) {
              vm.selected = vm.$props.current;
            }
          }, 500);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        });
    },
    update() {
      const vm = this;
      vm.$emit("input", vm.selected);
      vm.$emit("selected", vm.selected);
    },
  },
  mounted() {
    const vm = this;
    vm.fetchServices();
  },
};
</script>